import script from "./HeaderForPosts.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderForPosts.vue?vue&type=script&setup=true&lang=js"

import "./HeaderForPosts.vue?vue&type=style&index=0&id=d10ba4fc&lang=scss&scoped=true"

import exportComponent from "/Users/kobayashiyasutaka/Documents/Projects/murakihp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d10ba4fc"]])

export default __exports__